import * as constants from '../constants/CONSTANT';

const buildHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    Authorization: token
  };
};

const toJson = async (response) => {
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    const error = new Error(data?.message || 'Request failed');
    error.status = response.status;
    error.response = data;
    throw error;
  }
  return data;
};

const WebFormApi = {
  async listForms({ includeInactive = true, includeDeleted = false } = {}) {
    const params = new URLSearchParams({
      includeInactive: String(includeInactive),
      includeDeleted: String(includeDeleted)
    });

    const response = await fetch(
      `${constants.API_BASE_URL}/api/web-object/forms?${params.toString()}`,
      {
        method: 'GET',
        mode: 'cors',
        headers: buildHeaders()
      }
    );

    return toJson(response);
  },

  async getFormById(id) {
    const response = await fetch(
      `${constants.API_BASE_URL}/api/web-object/forms/${id}`,
      {
        method: 'GET',
        mode: 'cors',
        headers: buildHeaders()
      }
    );

    return toJson(response);
  },

  async createForm(payload) {
    const response = await fetch(
      `${constants.API_BASE_URL}/api/web-object/forms`,
      {
        method: 'POST',
        mode: 'cors',
        headers: buildHeaders(),
        body: JSON.stringify(payload)
      }
    );

    return toJson(response);
  },

  async updateForm(id, payload) {
    const response = await fetch(
      `${constants.API_BASE_URL}/api/web-object/forms/${id}`,
      {
        method: 'PUT',
        mode: 'cors',
        headers: buildHeaders(),
        body: JSON.stringify(payload)
      }
    );

    return toJson(response);
  },

  async deleteForm(id) {
    const response = await fetch(
      `${constants.API_BASE_URL}/api/web-object/forms/${id}`,
      {
        method: 'DELETE',
        mode: 'cors',
        headers: buildHeaders()
      }
    );

    return toJson(response);
  },

  async toggleFormStatus(id, isActive) {
    const response = await fetch(
      `${constants.API_BASE_URL}/api/web-object/forms/${id}/status`,
      {
        method: 'POST',
        mode: 'cors',
        headers: buildHeaders(),
        body: JSON.stringify({ is_active: isActive })
      }
    );

    return toJson(response);
  },

  async regenerateToken(id) {
    const response = await fetch(
      `${constants.API_BASE_URL}/api/web-object/forms/${id}/regenerate-token`,
      {
        method: 'POST',
        mode: 'cors',
        headers: buildHeaders()
      }
    );

    return toJson(response);
  },

  async getEmbedHtml(id, { regenerate = false, includeStyles = false, includeScript = false } = {}) {
    const params = new URLSearchParams({
      regenerate: String(regenerate),
      includeStyles: String(includeStyles),
      includeScript: String(includeScript),
      apiBaseUrl: constants.API_BASE_URL
    });

    const response = await fetch(
      `${constants.API_BASE_URL}/api/web-object/forms/${id}/embed?${params.toString()}`,
      {
        method: 'GET',
        mode: 'cors',
        headers: buildHeaders()
      }
    );

    return toJson(response);
  }
};

export default WebFormApi;
